import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { StrapiService } from 'app/core/shared-services/strapi.service';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Router, RouterLink } from '@angular/router';
import { FuseCardComponent } from '@fuse/components/card';
import { NgIf } from '@angular/common';
import {MatSelectModule} from '@angular/material/select';
import {MatCardModule} from '@angular/material/card';

import { RECAPTCHA_SETTINGS, RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings } from 'ng-recaptcha';
import { environment } from 'environments/environment';
import { Subject, takeUntil } from 'rxjs';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { GtmService } from 'app/core/shared-services/gtm.service';


@Component({
  selector    : 'app-contact-us',
  standalone  : true,
  imports     : [
                RecaptchaFormsModule,
                RecaptchaModule,
                MatButtonModule,
                FuseCardComponent,
                CommonModule,
                MatInputModule,
                MatCardModule,
                MatCheckboxModule,
                MatSelectModule,
                MatInputModule,
                MatFormFieldModule,
                NgIf,
                FormsModule,
                ReactiveFormsModule,
                MatIconModule,
                MatButtonModule,
                RouterLink
                ],

// configuration settings for reCAPTCHA module
  providers    :[{
    provide: RECAPTCHA_SETTINGS,
    useValue: {
      siteKey: environment.recaptchaSiteKeyTest,
    } as RecaptchaSettings,
  },],

  templateUrl : './contact-us.component.html',
  styleUrls   : ['./contact-us.component.scss']
})

export class ContactUsComponent implements OnInit
{

  Submit() {
      if (this.contactUsForm.invalid) {
        throw new Error('Form is invalid.');
      }
     else {}
      //Logic to push to Agility
      
  }
  
  public headerImage: string;
  public headerText: string;
  public image: string;
  contactUsForm: UntypedFormGroup;
  selected: any;
  
  private isScreenSmall: boolean;
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  // Captcha
  token: string|undefined;

  private referrer: string;


  /**
    * Constructor
  */
  constructor(
    private _formBuilder: UntypedFormBuilder,
    private _strapiService: StrapiService,
    @Inject(PLATFORM_ID) private platformId: any,
    private _fuseMediaWatcherService: FuseMediaWatcherService,
    private router: Router,
    private _gtmService: GtmService

  ) {
    this.token = undefined;
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {

    if (isPlatformBrowser(this.platformId)) {

      if(localStorage.getItem('currentURL')) {
        if(localStorage.getItem('currentURL') == window.location.href) {
          //this.referrer = window.location.href
        } else {
          this.referrer = localStorage.getItem('currentURL')
          localStorage.setItem('currentURL', window.location.href);
          localStorage.setItem('previousURL', this.referrer);
        }
      } else {
        localStorage.setItem('currentURL', window.location.href);
      }

      const route = window.location.href;
      const path = this.router.url;
      this._gtmService.pushEvent({ 
        event: 'page_view' ,
        page_url: route,
        page_path: path,
        page_title: 'contact_us_page' ,
        page_referrer: this.referrer ? this.referrer : route
      });
    }

    this.contactUsForm = this._formBuilder.group({

      FullName        : ['', Validators.required],
      EmailAddress    : ['', [Validators.required, Validators.email]],
      QueryCategory   : ['', Validators.required],
      MobileNumber    : ['', Validators.minLength(10)],
      Query           : ['', Validators.maxLength(500)],
      reCaptchaCheck   : [null, Validators.required],
      Submit          : ['']
    });

    // Subscribe to media changes
    this._fuseMediaWatcherService.onMediaChange$
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe(({matchingAliases}) =>
    {
        // Check if the screen is small
        this.isScreenSmall = !matchingAliases.includes('md');
    });

    // get content from Strapi
    this._strapiService.getContactUsScreenContent()
      .subscribe({
        next: (res: any) => {
          if(this.isScreenSmall) {
            this.headerImage = res.data.mobileImage.url;
          } else {
            this.headerImage = res.data.headerImage.url;
          }
          this.headerText = res.data.text;
          this.image = res.data.image.url;
     
        }
      });
  }

  /**
     * Whatsapp redirection
     */
  public redirectToWhatsApp() {
    
    if (isPlatformBrowser(this.platformId)) {
      window.open('https://api.whatsapp.com/send/?phone=0600687377&text=Please+can+you+assist+me', '_blank');

    }
  }

  /**
     * On destroy
     */
  ngOnDestroy(): void
  {
      // Unsubscribe from all subscriptions
      this._unsubscribeAll.next(null);
      this._unsubscribeAll.complete();
      localStorage.removeItem('catType');
  }
  
}